/**
 * Urun karti gorsel seridi -- Lefties referansi.
 *
 * Serit saf CSS scroll-snap ile calisiyor (component-card-product-gallery.css),
 * bu dosya yalnizca uc seyi ekliyor:
 *   1. <product-card-gallery> -- dongulu ok butonlari
 *   2. Dokunmatikte koyu beden seridini acan tek bir delege dinleyici
 *   3. Kaydirma sonrasi istemsiz urun sayfasi ziyaretini engelleyen tik korumasi
 *
 * Neden ozel eleman: her ok cifti kendi seridine ve kartin variant:change
 * olayina baglaniyor. facets.js (innerHTML) ve dynamic-load-more.js
 * (insertAdjacentHTML) ile eklenen kartlarda connectedCallback kendiliginden
 * calisiyor -- yeniden baglama kancasi gerekmiyor.
 *
 * Neden delege dinleyici (2 ve 3): bunlarin ornek durumu yok ve galerisi olmayan
 * kartlarda da gerekli. global.js:3374 mobil dokunma kancasi yalnizca
 * DOMContentLoaded'da baglandigi icin enjekte edilen kartlarda zaten calismiyordu.
 */

const GALLERY_DRAG_THRESHOLD = 10;

class ProductCardGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialised === 'true') return;
    this.dataset.initialised = 'true';

    this.track = this.closest('.product-card__actions')?.querySelector('[data-gallery-track]');
    if (!this.track) return;

    this.onClick = this.onClick.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);

    this.addEventListener('click', this.onClick);

    // Varyant degisince gorunen slayt gizlenmis olabilir; serit basa doner.
    this.card = this.closest('product-card');
    this.card?.addEventListener('variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.card?.removeEventListener('variant:change', this.onVariantChange);
  }

  onClick(event) {
    const button = event.target.closest('[data-gallery-direction]');
    if (!button) return;

    // Serit <a class="product-card__link"> icinde; oklar disinda ama tiklama
    // yine de yukari kabarip anchor'i tetikleyebilir.
    event.preventDefault();
    event.stopPropagation();

    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const lastLeft = scrollWidth - clientWidth;
    const isPrev = button.dataset.galleryDirection === 'prev';

    // Lefties gibi dongulu: ilk gorselde "onceki" son gorsele, son gorselde
    // "sonraki" ilk gorsele gider. Uclarda gecis aninda -- kaydirarak geri
    // sarmak aradaki butun gorselleri ters yonde gecirirdi.
    if (isPrev && scrollLeft <= 1) {
      this.track.scrollTo({ left: lastLeft, behavior: 'instant' });
    } else if (!isPrev && scrollLeft >= lastLeft - 1) {
      this.track.scrollTo({ left: 0, behavior: 'instant' });
    } else {
      this.track.scrollBy({ left: isPrev ? -clientWidth : clientWidth, behavior: 'smooth' });
    }
  }

  onVariantChange() {
    this.track?.scrollTo({ left: 0 });
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery);
}

/* --------------------------------------------------------------------------
   Dokunmatik: karta dokununca koyu beden seridi acilsin
   -------------------------------------------------------------------------- */

document.addEventListener(
  'pointerdown',
  (event) => {
    if (window.matchMedia('(hover: hover)').matches) return;

    const actions = event.target.closest('.product-card__actions');

    document.querySelectorAll('.product-card__actions.is--touched').forEach((element) => {
      if (element !== actions) element.classList.remove('is--touched');
    });

    if (actions) actions.classList.add('is--touched');
  },
  { passive: true }
);

/* --------------------------------------------------------------------------
   Kaydirma sonrasi tik korumasi

   Serit urun bagiantisinin icinde duruyor, yani yatay bir surukleme parmak
   kaldirildiginda urun sayfasina gitmeye calisir. Yakalama asamasinda, imlec
   esikten fazla yer degistirdiyse tiklama iptal ediliyor.
   -------------------------------------------------------------------------- */

let dragOrigin = null;

document.addEventListener(
  'pointerdown',
  (event) => {
    dragOrigin = event.target.closest('[data-gallery-track]') ? { x: event.clientX } : null;
  },
  { passive: true, capture: true }
);

document.addEventListener(
  'click',
  (event) => {
    if (!dragOrigin) return;

    const moved = Math.abs(event.clientX - dragOrigin.x) > GALLERY_DRAG_THRESHOLD;
    dragOrigin = null;

    if (moved && event.target.closest('[data-gallery-track]')) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  true
);
